import React from 'react'
import './certificado-digital-list.scss'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const CertificadoDigitalList = (props) => <DefaultDataTable data={props} />
